export const defaultLoadingPhases = [
  "Queue handshake",
  "Runtime wake",
  "Checkpoint ready",
  "Move delivery",
] as const;

export const playLoadingPhases = [
  "Room authority",
  "Model wake",
  "Reply transit",
  "Board resume",
] as const;
